import farms from 'config/constants/farms'
import { ecoFarm } from 'config/constants/ecoBoost'
import { isNilOrUndef } from './isNilOrUndef'

/**
 * pass in farm pid to check if farm supported NFT staking
 *
 * current supported case:
 *
 * ecoFarm has value
 *
 * enabledBoost = true
 *
 * @param pid
 * @returns boolean
 */
const isNftStakingSupported = (pid: number): boolean => {
  return isFarmBoostingSupported(pid) || isEcoFarmSupported(pid)
}

export const isFarmBoostingSupported = (pid: number): boolean => {
  const targetFarm = farms.find((farm) => farm.pid === pid)

  if (isNilOrUndef(targetFarm)) return false

  if (targetFarm.enableBoost) return true

  return false
}

export const isEcoFarmSupported = (pid: number): boolean => {
  const targetFarm = farms.find((farm) => farm.pid === pid)

  if (isNilOrUndef(targetFarm)) return false

  if (!targetFarm.ecoFarm) return false

  // 1. config in farms, restriction : only support 1 rewarderV2 in 1 farm
  const targetRewarder = targetFarm?.rewarders?.find(
    (rewarder) => !isNilOrUndef(rewarder.nft) && rewarder?.nft === targetFarm?.ecoFarm,
  )

  // 2. adding config in ecoFarm config
  if (!isNilOrUndef(ecoFarm[targetRewarder?.nft])) {
    return true
  }

  return false
}

export default isNftStakingSupported
